import { SearchItem } from '@ghosts-inc/design-system/components';
import { FilterAttribute } from '@/types/filterAttribute';

export type Background = 'transparent' | 'light' | 'dark';

export type FlatBuyerPreferences = {
  platforms: string[];
  specialties: string[];
  brands: string[];
  compositeCategories: string[];
  percentOffMsrpClassificationId: number | null;
  adminPrimaryOverride: string | null;
};

export type BuyerPreferences = {
  brands: SearchItem[];
  compositeCategories: string[];
  specialties: SearchItem[];
  platforms: SearchItem[];
  countries: SearchItem[];
  pricePerUnitInCentsMin: number | null;
  pricePerUnitInCentsMax: number | null;
  percentOffMsrpClassificationId: number | null;
};

export const filterAttributeToBuyerPreferenceKeyMap = {
  platforms: 'platforms',
  specialties: 'specialties',
  brands: 'brands',
  compositeCategories: 'compositeCategories',
  percentOffMsrp: 'percentOffMsrpClassificationId',
} as const;

export type BuyerPreferenceListingCollectionsFactories = {
  [K in FilterAttribute]: (index: number) => JSX.Element;
};

export type ListingHomePageRecommendation = {
  listingId: number;
  matchReason: string;
  sharedWithBuyerAt: Date;
};
